import styled, { css } from 'styled-components';

export const FilterWrapper = styled.div`
  background:transparent;
  ${(props) => props.active && css`
    position: relative;
    z-index: 2;`}
	${(props) => props.isDisabled && css`
		position: relative;
    z-index: 2;
		&:after {
			content:'';
			top:0;
			left:0;
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 1;
			background: #fff;
			opacity: 0.6;
			cursor: not-allowed;}`
}
`;

export const FilterSection = styled.div`
  position: relative;
  border-bottom : ${(props) => props.borderBtm ? '1px solid #dddddd' : ''};
  padding-bottom:${(props) => props.paddingBtm ? props.paddingBtm : ''};
  margin-bottom:${(props) => props.marginBtm ? props.marginBtm : ''};
`;

export const FilterInnerWrapper = styled.div`
    margin-bottom: ${(props) => props.marBtm ? props.marBtm : ''};
		.filter-calender {
			&:nth-of-type(2) {
				margin: 0;
			}
			margin-right: 5px;
			padding: 10px 2px;
		}
`;
export const MultiSelecGrouped = styled.div`
  display:flex;
  align-items:center;
  justify-content:space-between;
`;
export const MultiSelectBadge = styled.span`
  background: #EBECF0;
  border-radius:20px;
  color: #4a4a4a;
  display: flex;
  align-Items:center;
  font-size:10px;
  justify-content:center;
  width:20px;
  height:20px;

`;
export const MultiSelectlabel = styled.span`
  color:#9b9b9b;
  font-size:12px;
`;

export const SubDropDown = styled.div`
  margin-left: 14%;
  width: 86%;
`;
